import { scrollbar, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['2xl']};
  margin-right: ${theme.spacing.sm};
  padding: ${theme.spacing['2xl']};
  overflow: hidden auto;
  ${scrollbar({ trackMargin: 'sm' })};
`;
